import { modalStructures } from './structures'

export const Setup = typeModal => {
  return {
    callStructureModal: () => modalStructures.type(typeModal)
  }
}



// WEBPACK FOOTER //
// ./src/skeletons/modal.js